import { Component } from "@opten/compiler/metadata/component";
import { MapStyles } from "../shared/map";
import { MapSearcher } from "../shared/map-searcher";

@Component({ className: "js-map-filter" })
export class MapFilterComponent {
	private mapSearcher: MapSearcher;
	private download: HTMLLinkElement;

	constructor(private element: HTMLElement) {
		this.mapSearcher = new MapSearcher(element, window, {
			mapStyles: MapStyles,
			radiusBounds: parseInt(
				this.element.getAttribute("data-radius") || "0"
			),
		});
		this.download = element.querySelector(
			".js-map-filter-download"
		) as HTMLLinkElement;

		this.mapSearcher.filter.filters.forEach((filter) => {
			filter.addEventListener("change", () => {
				this.mapSearcher.search();
			});
		});

		if (this.download) {
			this.download.addEventListener("click", (e) => {
				const locations = this.mapSearcher.getActiveLocations();
				let href = this.download.getAttribute("data-href");
				if (locations && locations.length > 0) {
					href += href.indexOf("?") != -1 ? "&" : "?";
					href +=
						"&hallIds=" +
						locations
							.map((o) => o.element.getAttribute("data-id"))
							.join(",");
				}
				this.download.href = href;
			});
		}
	}
}
